import { commonValidations } from '../../../utils/validations';

export const commonFormInitialValues = {
  name: '',
  phone: '',
  email: '',
  team: '',
};

export const creditFormInitialValues = {
  issue: {
    ...commonFormInitialValues,
    reductionCertSeq: '',
  },
  move: {
    assignorName: '',
    assignorPhone: '',
    assignorEmail: '',
    assignorTeam: '',
    assigneeUserSeq: '',
    assigneeName: '',
    assigneePhone: '',
    assigneeEmail: '',
    assigneeTeam: '',
    projectSeq: '',
    amount: null,
    reason: '',
    reasonDetail: '',
    files: [],
  },
  offset: {
    ...commonFormInitialValues,
    projectSeq: '',
    amount: null,
    reason: '',
    reasonDetail: '',
  },
  retire: {
    ...commonFormInitialValues,
    projectSeq: '',
    amount: null,
    reason: '',
    reasonDetail: '',
  },
};

export const creditFormValidations = (isEn) => ({
  // 공통 필수 필드
  name: {
    required: isEn ? 'Please enter the name.' : '담당자명을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the name.' : '담당자명을 입력해주세요.';
      }
      return true;
    },
  },
  phone: commonValidations(isEn).phone,
  email: commonValidations(isEn).email,
  team: {
    required: isEn ? 'Please enter the department.' : '부서를 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the department.' : '부서를 입력해주세요.';
      }
      return true;
    },
  },
  reductionCertSeq: {
    required: isEn ? 'Please select the project.' : '사업을 선택해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please select the project.' : '사업을 선택해주세요.';
      }
      return true;
    },
  },
  // Move 전용 필수 필드
  assignorName: {
    required: isEn ? 'Please enter the assignor name.' : '양도인 담당자명을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the assignor name.' : '양도인 담당자명을 입력해주세요.';
      }
      return true;
    },
  },
  assignorPhone: commonValidations(isEn).phone,
  assignorEmail: commonValidations(isEn).email,
  assigneeUserSeq: {
    required: isEn ? 'Please select the assignee user.' : '양수인을 선택해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please select the assignee user.' : '양수인을 선택해주세요.';
      }
      return true;
    },
  },
  assigneeName: {
    required: isEn ? 'Please enter the assignee name.' : '양수인 담당자명을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the assignee name.' : '양수인 담당자명을 입력해주세요.';
      }
      return true;
    },
  },
  assigneePhone: commonValidations(isEn).phone,
  assigneeEmail: commonValidations(isEn).email,
  // Move, Offset, Retire 공통 필수 필드
  projectSeq: {
    required: isEn ? 'Please select the project.' : '사업을 선택해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please select the project.' : '사업을 선택해주세요.';
      }
      return true;
    },
  },
  amount: {
    required: isEn ? 'Please enter the amount.' : '수량을 입력해주세요.',
    validate: (value) => {
      if (!value || value === 0 || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the amount.' : '수량을 입력해주세요.';
      }
      return true;
    },
  },
  reason: {
    required: isEn ? 'Please select the reason.' : '사유를 선택해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please select the reason.' : '사유를 선택해주세요.';
      }
      return true;
    },
  },
});
